<template>
  <div v-if="false">
    <div
      v-if="this.roleType === 1 || this.roleType === 2 || this.roleType === 4 || this.roleType === 3 || this.roleType === 5"
      class="needBox">
      <h4 class="head">待办提醒</h4>
      <Row>
        <div v-if="this.roleType === 1 && this.data.noSubmitCount" class="box" @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.noSubmitCount }}</p>
              <p class="txt">考勤表未提交</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="this.roleType === 1 && this.data.auditRejectCount" class="box" @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.auditRejectCount }}</p>
              <p class="txt">考勤表被退回</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="(this.roleType === 1 || this.roleType === 2 || this.roleType === 5) && this.dataE.auditRejectCount"
             class="box" @click="gotoE()">
          <Row>
            <div>
              <p class="num">{{ this.dataE.auditRejectCount }}</p>
              <p class="txt">考评表被退回</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="noneloading && noneloadingE &&
        ((this.roleType === 1 && !this.data.auditRejectCount && !this.data.noSubmitCount)
          || (this.roleType === 2 && !this.data.auditWaitCount)
          || (this.roleType === 3 && !this.data.downloadWaitCount  && !this.data.confirmWaitCount)
          || (this.roleType === 4 && !this.data.downloadWaitCount  && !this.data.confirmWaitCount)
          || (this.roleType === 5 && !this.data.auditWaitCount)
          ) && (!this.dataE.auditRejectCount && !this.dataE.auditWaitCount && !this.dataE.noSubmitCount)"
             class="nonebox">
          <img alt="" class="img" src="../../assets/photo/none.png">
          <p>暂无待办事项</p>
        </div>
        <div v-if="this.roleType === 2 && this.data.auditWaitCount" class="box" @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.auditWaitCount }}</p>
              <p class="txt">考勤表待审核</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="this.roleType === 5 && this.data.auditWaitCount" class="box" @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.auditWaitCount }}</p>
              <p class="txt">考勤表待审核</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="(this.roleType === 4 || this.roleType === 3) && this.data.downloadWaitCount" class="box"
             @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.downloadWaitCount }}</p>
              <p class="txt">考勤表待下载</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div v-if="(this.roleType === 4 || this.roleType === 3) && this.data.confirmWaitCount" class="box"
             @click="goto()">
          <Row>
            <div>
              <p class="num">{{ this.data.confirmWaitCount }}</p>
              <p class="txt">考勤表待处理</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div
          v-if="(this.roleType === 1 || this.roleType === 2 || this.roleType === 5 || this.roleType === 4) && this.dataE.auditWaitCount"
          class="box"
          @click="gotoE()">
          <Row>
            <div>
              <p class="num">{{ this.dataE.auditWaitCount }}</p>
              <p class="txt">考评表待处理</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
        <div
          v-if="(this.roleType === 1 || this.roleType === 2 || this.roleType === 5 || this.roleType === 4) && this.dataE.noSubmitCount"
          class="box"
          @click="gotoE()">
          <Row>
            <div>
              <p class="num">{{ this.dataE.noSubmitCount }}</p>
              <p class="txt">考评表未提交</p>
            </div>
            <img alt="" class="img" src="../../assets/photo/need.png">
          </Row>
        </div>
      </Row>
    </div>
    <div v-if="this.roleType != 1" class="needBox" style="margin-top: 20px;height: 150px;">
      <h4>关键数据（ {{ time }} ） </h4>
      <Row>
        <div class="sbox">
          <i class="el-icon-s-order" style="font-size: 60px;color: #007aff;"></i>
          <div style="text-align: left;margin-left: 20px;">
            <p style="color: rgba(174, 174, 178, 1);font-size: 18px;margin-bottom: 10px;">本月出勤人数</p>
            <p style="color: rgba(16, 16, 16, 1);font-size: 24px;">{{ key && key.attendanceNumber }}</p>
          </div>
        </div>
        <div class="sbox">
          <i class="el-icon-s-order" style="font-size: 60px;color: #ff3a30;"></i>
          <div style="text-align: left;margin-left: 20px;">
            <p style="color: rgba(174, 174, 178, 1);font-size: 18px;margin-bottom: 10px;">本月新增人数</p>
            <p style="color: rgba(16, 16, 16, 1);font-size: 24px;">{{ key && key.entryNumber }}</p>
          </div>
        </div>
        <div class="sbox">
          <i class="el-icon-s-order" style="font-size: 60px;color: #ff9502;"></i>
          <div style="text-align: left;margin-left: 20px;">
            <p style="color: rgba(174, 174, 178, 1);font-size: 18px;margin-bottom: 10px;">本月离开单位人数</p>
            <p style="color: rgba(16, 16, 16, 1);font-size: 24px;">{{ (key && key.esignationNumber) }}</p>
          </div>
        </div>
      </Row>
    </div>
  </div>
</template>
<script>
import RegisteredEnterprise from '../component/registeredEnterprise.vue'
import {loginProfile} from "@/api/login";

export default {
  name: 'homeContent',
  components: {
    RegisteredEnterprise
    // showEchartsPie: () => import('../tradeUnion/showEchartsPie.vue'),
    // showEchartsLine: () => import('../tradeUnion/showEchartsLine.vue')
  },
  data() {
    return {
      personalImg: true,
      personal: {
        telephone: '',
        nikeName: '',
        imgPath: '',
        roleType: ''
      },
      data: {},
      dataE: {},
      roleType: '',
      key: {},
      time: '',
      noneloading: false,
      noneloadingE: false,

    }
  },
  mounted() {
    this.init()
    const date = new Date();
    this.time = date.getFullYear() + '年' + date.getMonth() + '月'
  },
  methods: {
    init() {
      let token = localStorage.getItem('getToken')
      let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
      let user = JSON.parse(userString);
      this.roleType = user.roleType;
      console.log(this.roleType)
      loginProfile().then(res => {
        this.personal = res.data.data
        localStorage.setItem('peopleName', res.data.data.nikeName)
        localStorage.setItem('peopleTel', res.data.data.telephone)
        localStorage.setItem('peopleOrgid', res.data.data.orgId)
        if (this.personal.imgPath) {
          this.personal.imgPath = res.data.data.imgPath
          this.personalImg = false
        } else {
          this.personalImg = true
        }
      })
    },
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.tableData = res.data.data.records
      this.loading = false
    },
    goto() {
      this.$router.push(
        {
          path: '/companyAttendance/companyAttendance'
        }
      )
    },
    gotoE() {
      this.$router.push(
        {
          path: '/companyEvaluation/companyEvaluation'
        }
      )
    }
  }
}
</script>

<style lang='less' scoped>
.nonebox {
  .img {
    width: 200px;
    margin-top: 10px;
  }

  p {
    width: 200px;
    text-align: center;
    color: #606060;
  }
}

.showBox {
  width: 100%;

  /deep/ .ivu-avatar-large.ivu-avatar-icon {
    font-size: 70px;
  }

  .show-word {
    font-size: 1rem;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
  }

  .show_datas {
    width: 15.4rem;
    height: 7.5rem;
    background: linear-gradient(90deg,
    rgba(251, 249, 255, 1) 0%,
    rgba(231, 238, 255, 1) 100%);
    border-radius: 1rem;
    margin-right: 2.5rem;
    margin-top: 1.2rem;
    display: inline-block;

    .show_words {
      font-size: 1.25rem;
      color: rgba(51, 51, 51, 1);
      padding: 1.3rem 0 0 1.2rem;
    }

    .show_num {
      font-size: 3rem;
      text-align: right;
      margin-right: 2.06rem;
      color: rgba(134, 137, 184, 1);
    }
  }
}

.needBox {
  width: 800px;
  box-shadow: #c0c0c0 4px 5px 10px 3px;
  border-radius: 10px;
  padding: 10px;

  .head {
    margin-bottom: 20px;
  }
}

.sbox {
  width: 231px;
  height: 100px;
  line-height: 20px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.box {
  cursor: pointer;
  margin-right: 10px;
  width: 205px;
  height: 74px;
  line-height: 20px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  border: 1px solid rgba(234, 234, 234, 1);
  padding: 10px;

  .img {
    width: 36px;
    height: 36px;
    margin-left: 60px;
    margin-top: 10px;
  }

  .num {
    text-align: left;
    color: #5B5E68;
    font-size: 28px;
    margin-bottom: 10px;
  }

  .txt {
    font-size: 12px;
    color: #989DAA;
  }
}

.btn {
  width: 80px;
  height: 30px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  border: 1px solid rgba(187, 187, 187, 1);
}
</style>
